/**
 * Sorting plugin for the grid
 * @class
 */
import Base from './client';

const Sort = function (grid) {
	this.grid = grid;

	// Listen for column sort request
	grid.addEventListener('fin-column-sort', _.bind(this.toggleSort, this));
	grid.addEventListener('fin-cell-enter', _.bind(this.cellEnter, this));
	grid.addEventListener('fin-cell-exit', _.bind(this.cellExit, this));

	// Cannot trust this event
	// grid.addEventListener('fin-canvas-mouseout', _.bind( this.canvasMouseOut, this ) );
	grid.div.addEventListener(
		'mouseleave',
		(this.onmouseleave = _.bind(this.canvasMouseOut, this)),
	);
};

Sort.prototype = _.extend(Object.create(Base.prototype), {
	// Replace constructor with ours
	constructor: Sort,

	/**
	 * @override
	 * @param {object} opts Options
	 */
	sort(opts) {
		if (this.order == null || this.columnIndex == null) {
			return;
		}

		opts = opts || {};

		const grid = this.grid;

		// Sort the index
		const field = grid.behavior.getColumn(this.columnIndex).properties.name;
		grid.canvas.dispatchEvent(
			new CustomEvent('nx-sort', {
				detail: {
					column: field,
					order: this.order,
				},
			}),
		);
	},

	/**
	 * Destroy
	 * @override
	 * @param {Hypergrid} grid Grid
	 */
	uninstall(grid) {
		// Clean up listeners
		grid.removeEventListener('fin-column-sort', this.toggleSort);
		grid.removeEventListener('fin-cell-exit', this.cellExit);
		grid.removeEventListener('fin-cell-enter', this.cellEnter);

		// Cannot trust this event
		// grid.removeEventListener('fin-canvas-mouseout', this.canvasMouseOut );
		grid.div.removeEventListener('mouseleave', this.onmouseleave);
	},

	/**
	 * @override
	 * @param {object} opts Options
	 */
	unsort(opts) {
		opts = opts || {};

		const grid = this.grid;
		const behavior = grid.behavior;

		if (this.order != null && this.columnIndex != null) {
			// Just easier this way
			grid.clearSelections();
			grid.selectionChanged();

			// Unset icon
			behavior.getColumn(this.columnIndex).properties.columnRightIcon = '';

			this.columnIndex = null;
			this.order = null;

			grid.canvas.dispatchEvent(new CustomEvent('nx-unsort'));
		}
	},

	/**
	 * @override
	 */
	updateData() {
		// Do nothing
	},
});

export default Sort;
